import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function MidtermDocumentDialog({
  midtermDocuments,
  projectId,
  projectProposalId,
  visible,
  setVisible,
}) {
  const { t } = useTranslation();
  const formatNo = (value, options) => <div>{options.rowIndex + 1}</div>;
  const formatName = ({ id, version }) => (
    <div>
      <Link to={`/projects-submit/${projectId}/${projectProposalId}/${id}/midterm-document?tab=1`}>
        {t('project.viewList.midtermDocumentDialog.versionText')} {version}
      </Link>
    </div>
  );
  const formatSubmitDate = ({ submittedAt }) => (
    <div>
      {submittedAt
        ? new Date(submittedAt).toLocaleDateString()
        : t('project.viewList.midtermDocumentDialog.everSubmit')}
    </div>
  );
  const formatStatus = ({ submittedAt, summaryReportRevises }) => {
    if (!submittedAt) {
      return <div>{t('project.viewList.midtermDocumentDialog.everSubmit')}</div>;
    }
    const hasRevise = summaryReportRevises?.some(({ isRevise }) => isRevise);

    if (hasRevise) {
      return <div>{t('project.viewList.midtermDocumentDialog.hasRequest')}</div>;
    }

    return <div>{t('project.viewList.midtermDocumentDialog.submitted')}</div>;
  };

  const formatCouncilResult = ({ council }) => {
    const councilResultStatus = council?.projectProposalCouncils?.[0]?.councilStatus;
    return (
      <div>
        {councilResultStatus
          ? t(`project.viewList.midtermDocumentDialog.councilResult.${councilResultStatus}`)
          : t('project.viewList.midtermDocumentDialog.councilResult.everCouncilResult')}
      </div>
    );
  };

  return (
    <Dialog
      header={t('project.viewList.midtermDocumentDialog.title')}
      visible={visible}
      onHide={() => setVisible(false)}
      draggable={false}
      style={{ maxWidth: '60rem' }}
      className="w-full"
    >
      <DataTable value={midtermDocuments} showGridlines tableStyle={{ minWidth: '50rem' }}>
        <Column
          style={{ width: '4%' }}
          className="text-center"
          body={formatNo}
          header={t('project.viewList.midtermDocumentDialog.no')}
        />
        <Column
          style={{ width: '40%' }}
          body={formatName}
          header={t('project.viewList.midtermDocumentDialog.version')}
        />
        <Column
          style={{ width: '15%' }}
          body={formatSubmitDate}
          className="text-center"
          header={t('project.viewList.midtermDocumentDialog.submitDate')}
        />
        <Column
          style={{ width: '15%' }}
          body={formatStatus}
          className="text-center"
          header={t('project.viewList.midtermDocumentDialog.status')}
        />
        <Column
          style={{ width: '18%' }}
          className="text-center"
          body={formatCouncilResult}
          header={t('project.viewList.midtermDocumentDialog.councilResult.label')}
        />
      </DataTable>
    </Dialog>
  );
}

MidtermDocumentDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  midtermDocuments: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  projectProposalId: PropTypes.string.isRequired,
};
export default MidtermDocumentDialog;
